import { HttpClient } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';

import { environment } from '~/core/core.module';

export interface ClientConfig {
  psPdfKitKey: string;
  enabledModules: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private readonly state = {
    config: signal<ClientConfig>(null)
  } as const;

  $enabledModules = toObservable(computed(() => this.state.config()?.enabledModules));

  constructor(private httpClient: HttpClient) {}

  clientConfig() {
    this.httpClient
      .get<ClientConfig>(`${environment.BACKEND_URL}/clientconfig`)
      .pipe(take(1))
      .subscribe((config: ClientConfig) => {
        environment.PSPDFKIT_KEY = config.psPdfKitKey;
        this.state.config.set({ ...config, enabledModules: [...config.enabledModules, 'DOSSIER'] });
      });
  }
}
